import axios from 'axios'
import router from '@/router'

export default {
  actions: {
    async getCurrentUser({ commit, dispatch, rootState }) {
      new Image().src = '/pwa-api/ping?src=getCurrentUser-pre';
      var result;
       try {
          const token = localStorage.getItem('token');
          const headers = {};
          if (token) headers['user-auth-key'] = token;
          new Image().src = '/pwa-api/ping?src=getCurrentUser-about-to-call-' + (token ? 'has-token' : 'no-token');
          new Image().src = '/pwa-api/ping?src=about-to-call-axios';
          return await axios
            .get('/crm/team_users/auth_info/', { headers })
            .then(resp => {
              new Image().src = '/pwa-api/ping?src=axios-success-status-' + resp.status;
              const detail = resp.data.detail;
              const user = resp.data.user;
              if (detail) {
                result = {
                  status: 'error',
                  detail: resp.data.detail
                };
                if (resp.data.detail === 'Authorization error'){
                  dispatch('logout')
                  router.push('/login');
                } else
                  return Promise.reject(resp.data)
              } else if (user) {
                commit('auth/setUser', user, { root: true });
                commit('add/setPermissions', user, { root: true });
                commit('edit/setPermissions', user, { root: true });
                result = {
                  status: 'ok',
                  user: user
                };
              }
              return result;
            })
            .catch(err => {
              new Image().src = '/pwa-api/ping?src=axios-caught-' + (err.response ? err.response.status : 'no-resp');
              if (!err.response || err.response.status !== 200) {
                dispatch('logout')
                router.push('/login');
              }
              return null;
            })
           .catch(err => {
              if (!err.response || err.response.status !== 200) {
                dispatch('logout')
                router.push('/login');
              }
             return null;
           })
       } catch (e) {
         throw e;
       }
    },



    async getCurrentUserStatistics({ commit, dispatch, rootState }) {
      var result;
      try {
          fetch('/pwa-api/ping?src=about-to-call-axios').catch(() => {});
          const token = localStorage.getItem('token');
          const headers = {};
          if (token) headers['user-auth-key'] = token;
          return await axios
            .get('/crm/team_users/auth_info/', { headers })
            .then(resp => {
              fetch('/pwa-api/ping?src=axios-success-status-' + resp.status).catch(() => {});
              const detail = resp.data.detail;
              const user = resp.data.user;
              const stats = resp.data.stats;
              if (detail) {
                result = {
                  status: 'error',
                  detail: resp.data.detail
                };
                if (resp.data.detail === 'Authorization error'){
                  dispatch('logout')
                  router.push('/login');
                } else
                  return Promise.reject(resp.data)
              } else if (user) {
                commit('auth/setUser', user, { root: true });
                commit('add/setPermissions', user, { root: true });
                commit('edit/setPermissions', user, { root: true });
                result = {
                  status: 'ok',
                  user: user,
                  stats: stats
                };
              }
              return result;
            })
            .catch(err => {
              fetch('/pwa-api/ping?src=axios-caught-' + (err.response ? err.response.status : 'no-resp')).catch(() => {});
              if (!err.response || err.response.status !== 200) {
                dispatch('logout')
                router.push('/login');
              }
              return null;
            })
          .catch(error => console.log(error));
      } catch (e) {
        console.log(e);
        throw e;
      }
    },

  }
}